module.exports = __webpack_public_path__ + "static/media/blom-pysanky-thumb-74.75978183.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blom-pysanky/blom-pysanky-thumb-74.jpg
// module id = 4034
// module chunks = 15